import { FC } from "react";
import { FieldInputProps } from "react-final-form";

import { IPickerListItem, Picker, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import PriorityIndicator from "components/priority/PriorityIndicator";
import { TICKET_PRIORITY_LABEL_MAP } from "constants/tickets/priorities";
import { TicketPriority } from "interfaces/entities/ticket";
import { IRuleActionPriority } from "store/entities/rules/interfaces";
import { withVar } from "themes/helpers";

import { shortPickerStyles } from "../../styles";
import { changeActionValues } from "../utils";

interface IProps {
  input: FieldInputProps<IRuleActionPriority>;
}

export const Priority: FC<IProps> = ({ input }) => {
  const onSelect = (selected: IPickerListItem[] | null): void => {
    if (!selected) {
      return;
    }
    const itemKey = parseInt(selected[0].key, 10) as TicketPriority;
    changeActionValues(input, { priority: itemKey });
  };

  const foundOption = options.find(opt => opt.key === input.value?.priority?.toString());
  const priority = foundOption ? [foundOption] : [];

  return (
    <Picker
      options={options}
      onSelect={onSelect}
      selected={priority}
      placeholder="Select priority..."
      hideClearButton
      data-testid="priority-picker"
      css={shortPickerStyles}
    />
  );
};

const PriorityListElement: FC<{ priority: TicketPriority }> = ({ priority }) => (
  <Flex gap={withVar(SpacingToken.Spacing2)} alignItems="center">
    <PriorityIndicator priority={priority} />
    {TICKET_PRIORITY_LABEL_MAP[priority]}
  </Flex>
);

const options: IPickerListItem[] = [
  {
    key: TicketPriority.Urgent.toString(),
    name: "Urgent",
    customElement: {
      listItemBody: <PriorityListElement priority={TicketPriority.Urgent} />,
      selectedItemBody: <PriorityListElement priority={TicketPriority.Urgent} />,
    },
  },
  {
    key: TicketPriority.High.toString(),
    name: "High",
    customElement: {
      listItemBody: <PriorityListElement priority={TicketPriority.High} />,
      selectedItemBody: <PriorityListElement priority={TicketPriority.High} />,
    },
  },
  {
    key: TicketPriority.Medium.toString(),
    name: "Medium",
    customElement: {
      listItemBody: <PriorityListElement priority={TicketPriority.Medium} />,
      selectedItemBody: <PriorityListElement priority={TicketPriority.Medium} />,
    },
  },
  {
    key: TicketPriority.Low.toString(),
    name: "Low",
    customElement: {
      listItemBody: <PriorityListElement priority={TicketPriority.Low} />,
      selectedItemBody: <PriorityListElement priority={TicketPriority.Low} />,
    },
  },
];
